<script>
    import { onMount, onDestroy } from 'svelte';
    import { SigningStargateClient } from '@cosmjs/stargate';
    import { initialAudio } from '../audioStore.js';

    const adventure = {
    start: {
        description: "You are a Stargaze Command officer deployed to defend Planet Earth against alien invasion. Your squad is pinned down in the ruined capitol. Do you try to find higher ground or attempt to flank the alien position? What you do here today will have far-reaching consequences.",
        image: "/ruined_city.jpg",
        choices: {
            higher: "higherGround",
            flank: "flankPosition"
        }
    },
    higherGround: {
        description: "You've reached a building that looks directly down on the alien position. Do you let the snipers open fire or use it to call in air support?",
        image: "/tall_building.jpg",
        choices: {
            sniper: "sniperOutcome",
            airSupport: "airSupportOutcome"
        }
    },
    flankPosition: {
        description: "You've successfully flanked the aliens, but you've discovered their numbers are greater than expected. Still, you have an elite squad of trained soldiers under your command. Do you engage or retreat to warn your troops?",
        image: "/alien_horde.jpg",
        choices: {
            engage: "engageOutcome",
            retreat: "retreatOutcome"
        }
    },
    sniperOutcome: {
        description: "Your precision shots decimate a few aliens, but one of their scouts comes up from behind behind you. You take cover and return fire, killing the alien, but not before it calls for reinforcements. It looks like that air support is needed after all.",
        
        image: "/sniper_defeat.jpg",
        choices: {
            continue: "airSupportOutcome" 
        }
    },
    airSupportOutcome: {
        description: "Air support arrives, raining hellfire on the alien positions. Your squad cheers the blasts and you allow yourself a smile. The smell of burning aliens fills your nose. The path is clear, but the noise has attracted even more invaders. In the distance you see an alien forward base. Do you advance or defend your position?",
        image: "/airstrike.jpg",
        choices: {
            advance: "alienBase",
            defend: "defendPosition"
        }
    },
    engageOutcome: {
        description: "Your surprise attack catches the aliens off-guard, but you're horribly outnumbered. Do you use grenades or call for backup? Your squad is looking to you for guidance.",
        image: "/outnumbered.jpg",
        choices: {
            grenades: "grenadeOutcome",
            backup: "backupOutcome"
        }
    },
    retreatOutcome: {
        description: "You've successfully regrouped with your troops and they hurry about setting up defenses. Now, do you set up an ambush or try to sabotage alien equipment? ",
        image: "/squad_planning.jpg",
        choices: {
            ambush: "ambushOutcome",
            sabotage: "sabotageOutcome"
        }
    },
    alienBase: {
        description: "You've reached the alien base. Citizens look out from the rubble, filling you with hope seeing so many survived. Do you use explosives to destroy the base or attempt to capture the alien technology within?",
        image: "/alien_base.jpg",
        choices: {
            explosives: "explosivesOutcome",
            capture: "captureOutcome"
        }
    },
    defendPosition: {
        description: "You're holding your ground, but supplies are running low. Your squad is letting the aliens get close before firing. Do you make a supply run or conserve ammo?",
        image: "/low_supplies.jpg",
        choices: {
            supplyRun: "supplyRunOutcome",
            conserve: "conserveOutcome"
        }
    },
    grenadeOutcome: {
        description: "Well thrown grenades take out swaths of aliens, but one of the blasts has injured you. It's just a scratch you say. Press on or fall back?",
        image: "/grenade_aftermath.jpg",
        choices: {
            pressOn: "pressOnInjured",
            fallBack: "fallBackOutcome"
        }
    },
    backupOutcome: {
        description: "Backup arrives just in time. Your troops are able to secure the streets. Civilians are told to evacuate the way you came in. Together, feeling stonger than ever, you push towards the alien base.",
        image: "/backup_arrival.jpg",
        choices: {
            continue: "alienBase"
        }
    },
    ambushOutcome: {
        description: "Your ambush is successful, but you've attracted the attention of a massive alien war machine. It tears apart one of your scouts and bears in on your position. Fight it or evade?",
        image: "/alien_war_machine.jpg",
        choices: {
            fight: "fightWarMachine",
            evade: "evadeWarMachine"
        }
    },
    sabotageOutcome: {
        description: "Finding an alien outpost, You disable their communications. Alarms start blaring. The aliens have left behind technology. Escape with some tech or push deeper into enemy territory?",
        image: "/alien_alarms.jpg",
        choices: {
            escape: "escapeWithTech",
            pushDeeper: "alienBase" 
        }
    },
    explosivesOutcome: {
        description: "The base is destroyed in an epic explosion worthy of the gods, dealing a major blow to the alien invasion. Unfortunately you were caught in the blast. A hero to be sure, but a dead one.",
        image: "/base_explosion.jpg",
        choices: {
            continue: "death"
        }
    },
    captureOutcome: {
        description: "You've secured vital alien tech, but reinforcements are coming. Make a daring escape with the technology or defend your position?",
        image: "/alien_tech.jpg",
        choices: {
            escape: "escapeWithTech",
            defend: "defendTech"
        }
    },
    supplyRunOutcome: {
        description: "During a supply run, you discover a badly wounded alien surrounded by dead ones. Your comms specialist says he thinks he can translate. The rest of your squad wants its head. Interrogate it or end its suffering?",
        image: "/wounded_alien.jpg",
        choices: {
            interrogate: "alienWeapon",
            endSuffering: "mercyKill" 
        }
    },
    mercyKill: {
    description: "You choose mercy, ending the alien's pain. This act of compassion is witnessed by others. Do you report this to your superiors or keep it a secret?",
    image: "/compassion_scene.jpg",
    choices: {
        report: "reportCompassion",
        secret: "secretCompassion"
    }
},

reportCompassion: {
    description: "Your act of mercy becomes known, leading to a shift in policy towards alien encounters. You're now seen as a bridge between species. Will you advocate for peace or focus on your career?",
    image: "/policy_shift.jpg",
    choices: {
        advocatePeace: "peaceAdvocate",
        focusCareer: "careerFocus"
    }
},

secretCompassion: {
    description: "Keeping your act secret, you continue your duties, but the memory haunts you. Eventually, you decide to either reveal your actions or live with the secret.",
    image: "/haunted_by_secret.jpg",
    choices: {
        reveal: "revealSecret",
        liveWithSecret: "careerFocus"
    }
},

revealSecret: {
    description: "Revealing your secret act of mercy changes public perception. You're seen as a hero who values life. Now, do you use this to advocate for peace or focus on your career?",
    image: "/hero_reveal.jpg",
    choices: {
        advocatePeace: "peaceAdvocate",
        focusCareer: "careerFocus"
    }
},

peaceAdvocate: {
    description: "You become a vocal advocate for peace, leading to treaties and understanding between humans and aliens. Your efforts culminate in a lasting peace.",
    image: "/peace_treaty.jpg",
    choices: {
        retire: "peacefulRetirement"
    }
},

careerFocus: {
    description: "Focusing on your career, you rise through the ranks, but the memory of your compassion influences your decisions, leading to subtle changes in policy. Eventually, you retire with honors.",
    image: "/career_peak.jpg",
    choices: {
        retire: "peacefulRetirement"
    }
},
    conserveOutcome: {
        description: "You've conserved ammo, but aliens have breached your position. Knowing your troops will fight to the last man, you weigh your options. Hand-to-hand combat or spend some ammo on a last stand?",
        image: "/breach.jpg",
        choices: {
            handToHand: "death",
            lastStand: "lastStandOutcome" 
        }
    },
    lastStandOutcome: {
        description: "You've made a glorious last stand, and warriors past would be proud, but the aliens are overwhelming. You witness fellow soldiers you've known your whole life give theirs for this planet. Is it time to surrender or keep fighting to the bitter end?",
        image: "/last_stand.jpg",
            choices: {
            surrender: "death",
            fight: "desperateMeasures"
        }
    },
    desperateMeasures: {
        description: "In a desperate move, drawing on all your training and experience, you decide to give your snipers the remaining ammo and set up a kill box with the last of the explosives. It works, and with ammunition running low, you must choose between a risky retreat or a final sacrificial stand with whatever you have left.",
        image: "/desperate_fight.jpg",
        choices: {
            riskyRetreat: "manualWeaponsRetreat",
            finalStand: "finalBattle"
    }
},
    finalBattle: {
        description: "You choose to make your final stand here. The battle is fierce, and though you fight valiantly, the outcome is inevitable.",
            image: "/final_stand.jpg",
            choices: {
            continue: "death"
        }
},
    pressOnInjured: {
        description: "Despite your injury, you've reached a critical alien facility. Soldiers keep asking you if your alright. You wonder if you should destroy the facility or call for extraction?",
        image: "/critical_facility.jpg",
        choices: {
            destroy: "destroyFacility",
            extract: "extractionCall" 
        }
    },
    extractionCall: {
        description: "You've called for evac, but the aliens are closing in and assets won't reach you in time. You remember a story your father once told about how he and his men were on their own exactly like this and that they made it out alive. You asked how he did it and he just smiled and said: We set the world on fire that day.",
        image: "/critical_facility.jpg",
        choices: {
            destroy: "destroyFacility"
        }
    },
    destroyFacility: {
        description: "You've blown what turned out to be a staging area for the aliens sky-high, but the explosion has drawn the attention of an alien war machine. Fight it or retreat to a defensible position?",
        image: "/facility_explosion.jpg",
        choices: {
            fight: "fightWarMachine",
            retreat: "fallBackOutcome" 
        }
    },
    fallBackOutcome: {
        description: "You give the order for your men to fall back to a defensible position. Regroup with main forces or start guerrilla operations?",
        image: "/defensible_position.jpg",
        choices: {
            regroup: "squadRegroup",
            guerrilla: "guerrillaWarfare"
        }
    },
    guerrillaWarfare: {
    description: "You choose guerrilla tactics, hitting the enemy where they least expect it. Many small victories ensue. During one raid, you capture some alien technology. Do you use it to enhance your guerrilla operations or keep using current tactics?",
    image: "/guerrilla_tech.jpg",
    choices: {
        enhanceGuerrilla: "advancedGuerrilla",
        stayHuman: "supplyRunOutcome"
    }
},
advancedGuerrilla: {
    description: "With enhanced guerrilla tactics, you become a major thorn in the alien's. However, the alien tech is easily detected and this ulimately leads to your death.",
    image: "/hit_and_run.jpg",
    choices: {
        continue: "death"
    }
},
    fightWarMachine: {
        description: "Your men fight the monstrosity bravely as you direct your snipers to look for a way to take it down. Recon radios they found two weak spot in the war machine. Target its power source or its weapons?",
        image: "/war_machine_weakness.jpg",
        choices: {
            powerSource: "destroyPowerSource",
            weapons: "disableWeapons"
        }
    },
    evadeWarMachine: {
        description: "You manage to lose the war machine in the ruins. While doing so you stumble upon an alien armory. Do you attempt to steal alien tech or plant a tracker?",
        image: "/alien_armory.jpg",
        choices: {
            stealWeapon: "alienWeapon",
            plantTracker: "trackerPlanted"
        }
    },
    escapeWithTech: {
        description: "You've escaped with alien tech. Head to the extraction point or attempt to use the tech against the aliens?",
        image: "/escape_with_tech.jpg",
        choices: {
            extraction: "techExtraction",
            useAgainstAliens: "techWeapon"
        }
    },
    defendTech: {
        description: "While defending, one of your soldiers accidentally activates the alien tech. It hums with power. Use it or destroy it?",
        image: "/activated_tech.jpg",
        choices: {
            use: "useMysteriousTech",
            destroy: "destroyMysteriousTech"
        }
    },
    destroyPowerSource: {
        description: "You've successfully destroyed the war machine's power source. In the explosion, you uncover a hidden underground facility. Investigate or call for backup?",
        image: "/hidden_facility.jpg",
        choices: {
            investigate: "investigateFacility",
            callBackup: "facilityBackup"
        }
    },
    disableWeapons: {
        description: "The war machine is disarmed but still operational. It seems to be transmitting data. Attempt to decrypt or destroy the transmitter?",
        image: "/disabled_warmachine.jpg",
        choices: {
            decrypt: "decryptAlienData",
            destroyTransmitter: "stopTransmission"
        }
    },
    alienWeapon: {
        description: "You've acquired a powerful alien weapon. It hums as you hold it. It looks like something your forces would use, but the alien design is unmistakable. Do you test it out or save it for later?",
        image: "/alien_weapon.jpg",
        choices: {
            test: "testAlienWeapon",
            save: "saveForLater"
        }
    },
    trackerPlanted: {
        description: "The tracker reveals a massive alien mothership approaching Earth. Warn command or attempt to infiltrate it?",
        image: "/alien_mothership.jpg",
        choices: {
            warn: "warnCommand",
            infiltrate: "infiltrateMothership"
        }
    },
    techExtraction: {
        description: "At the extraction point, you're ambushed by alien forces. Use the tech as a bargaining chip or risk an all out firefight?",
        image: "/extraction_ambush.jpg",
        choices: {
            bargain: "peaceNegotiation",
            firefight: "extractionFirefight"
        }
    },
    extractionFirefight: {
        description: "You've fought off the ambush, but the extraction team is delayed. As your squad runs out of ammo, thousands of aliens approach. Game over man, game over, one of the soldiers says. You know he's right, so with no other options, you activate the alien tech.",
        image: "/cooler.jpg",
        choices: {
            continue: "useMysteriousTech"
        }
    },
    techWeapon: {
        description: "The alien tech is a powerful but unstable weapon. Opting to use it, you find it's more powerful than you expected. The weapon explodes, taking you and the aliens with it.",
        image: "/unstable_weapon.jpg",
        choices: {
            continue: "death"
        }
    },
    useMysteriousTech: {
        description: "The tech creates a temporal field, showing glimpses of the past alien invasion. You swear you see your grandfather waving you off? Learn from history or focus on the present threat?",
        image: "/temporal_field.jpg",
        choices: {
            learnHistory: "alienInvasionHistory",
            presentThreat: "focusPresent"
        }    
    },
    alienInvasionHistory: {
        description: "While you were busy studying the past, the aliens are able to hack the technology. They kill you with a self-destruct code.",
        image: "/temporal_field_blast.jpg",
        choices: {
            continue: "death" 
        }
    },
    focusPresent: {
        description: "You focus on the battle happening now, using the alien tech to turn the tide. Aliens turn to goo as the weapon emits purple doom. After slaying all the aliens in sight, the weapon runs out of charge. Do you push towards the alien command center or fortify your position?",
        image: "/using_alientech.jpg",
        choices: {
            pushCommand: "commandCenter",
            fortifyPosition: "newDefense" 
    }
},
    destroyMysteriousTech: {
        description: "Destroying the tech releases a massive EMP, disabling nearby alien and human technology. Retreat to manual weapons or push forward while aliens are vulnerable?",
        image: "/emp_aftermath.jpg",
        choices: {
            retreat: "manualWeaponsRetreat", 
            pushForward: "exploitVulnerability" 
        }
    },
    manualWeaponsRetreat: {
        description: "You order retreat, and are successful. Soldiers toss their spent laser rifles for traditional ones. Do you regroup with your squad or set up a new defensive line?",
        image: "/manual_retreat.jpg",
        choices: {
            regroupSquad: "squadRegroup",
            newDefensiveLine: "newDefense"
    }
},
    exploitVulnerability: {
        description: "You push forward while the aliens are disoriented. Sure feels good to be on the offensive. Do you target their command center or sabotage their supply lines?",
        image: "/exploit_vulnerability.jpg",
        choices: {
            targetCommand: "commandCenter",
            sabotageSupplies: "fleetSabotage" 
    }
},
    commandCenter: {
        description: "You've reached the alien command center. A signal coordinating ground forces is detected by your comms specialist and as she's speaking you notice a shadowy figure in one of the higher windows of the alien structure. Do you attempt to stop their transmission or confront their leader?",
        image: "/alien_command_center.jpg",
        choices: {
            stopTransmission: "stopTransmission",
            confrontLeader: "alienLeader"
        }
},
alienLeader: {
    description: "You confront the alien leader and know with one look how this is going down. He's studying you, but he's scared. Do you attempt to negotiate peace or capture him for interrogation?",
    image: "/alien_leader_confrontation.jpg",
    choices: {
        negotiatePeace: "peaceNegotiation",
        captureLeader: "alienPrisoners"
    }
},

peaceNegotiation: {
    description: "Negotiations with the alien leader are tense. He threatens the remaining human population and you threaten to visit his home planet with his own tech. Do you agree to a ceasefire or demand his full surrender?",
    image: "/peace_talks.jpg",
    choices: {
        ceasefire: "peaceTreaty",
        fullSurrender: "alienSurrender"
    }
},

    squadRegroup: {
        description: "Your squad has regrouped. Your men are tired and low on ammo. As you let them rest, you notice the entrance to a hidden tunnel. You rally your troops and decide to go in.",
        image: "/squad_regroup.jpg",
        choices: {
            continue: "investigateFacility"
    }
},
    newDefense: {
        description: "You've set up a new defensive line. Your men are holding and your leadership keeps morale high. Your communication specialist alerts you to a strange signal she's picked up. You order her to decrypt the signal. It is vital to the war effort.",
        image: "/new_defense.jpg",
        choices: {
            continue: "decryptAlienData"
    }
},
    investigateFacility: {
        description: "Inside the facility, you find aliens conducting experiments on humans. They don't even look like humans anymore. The aliens have done unspeakable things to these people. Most look too far gone. A handful gather around you. Free all the captives or gather intelligence and take the ones who can at least walk?",
        image: "/alien_experiments.jpg",
        choices: {
            freeHumans: "rescueMission",
            gatherIntel: "crucialIntelligence" 
        }
    },
    crucialIntelligence: {
    description: "You gather critical intelligence about the alien plan. They came here to take over the planet and enslave humans. There are some mentions of human brains as a delicacy, but you're not sure about the translation. A mothership has been dispatched and is on the way. Command needs to know about this. You order your men to fallback to HQ.",
    image: "/intelligence_gathering.jpg",
    choices: {
        continue: "warnCommand"
    }
},
rescueMission: {
    description: "You free the terribly mistreated captives, but the aliens are alerted. As recued prisoners are thanking you, you hear the sound of alien weapon fire, and then silence.",
    image: "/rescue_mission.jpg",
    choices: {
        continue: "death"
        }
    },
    facilityBackup: {
        description: "Backup arrives, but so do alien reinforcements. A clash ensues. You and your men are able to escape with some alien tech.",
        image: "/backup_clash.jpg",
        choices: {
            continue: "alienTechnology"
        }
    },
    decryptAlienData: {
        description: "You've decrypted the alien battle plans. They reveal a massive mothership is headed for the planet. Do you contact command or attempt to infiltrate the mothership?",
        image: "/decrypted_plans.jpg",
        choices: {
            exploitNow: "spaceAssault",
            shareCommand: "warnCommand"
        }
    },
    stopTransmission: {
        description: "You've stopped the alien transmission, but there is chatter that the aliens are mobilizing an elite force to deal with you. Do you prepare an ambush or flee the area?",
        image: "/alien_elites.jpg",
        choices: {
            prepareAmbush: "ambushElites",
            fleeArea: "strategicRetreat"
        }
    },
    strategicRetreat: {
    description: "You retreat, but the aliens are on your tail. One of your best men sacrifices himself to buy you time, but the aliens keep coming. You have no choice but to defend this position. These elites are unlike anything you've seen before.",
    image: "/strategic_retreat.jpg",
    choices: {
        newDefensiveLine: "defensiveStance"
    }
},
ambushElites: {
    description: "You prepare to lead the aliens into a trap set by your squad. Somehow, you end up surrounded. Now you know why they are called elites.",
    image: "/leading_into_trap.jpg",
    choices: {
        continue: "death"
    }
},
defensiveStance: {
    description: "You set up a strong defensive position. A brilliant speech fills your men with courage. The aliens attack, but your soldiers hold. In the aftermath, one of the elites turns out to be a high-ranking alien officer.",
    image: "/defensive_stance.jpg",
    choices: {
        negotiateSurrender: "alienSurrender"
    }
},
    testAlienWeapon: {
        description: "You have a shot at an alien command center, but who knows what's in there. Take the shot or keep the weapon?",
        image: "/command_center_shot.jpg",
        choices: {
            takeShot: "commandCenterDestroyed",
            preserve: "saveForLater" 
        }
    },
    commandCenterDestroyed: {
        description: "The alien command center is destroyed. The aliens are in disarray. Do you press the attack or attempt to negotiate a peace?",
        image: "/command_center_destroyed.jpg",
        choices: {
            pressAttack: "alienSurrender",
            negotiate: "peaceNegotiation"
        }
    },
    saveForLater: {
        description: "Your troops advance beyond the outter perimeter and the going is slow. You come across a group of civilians hiding in a building. They say a high-ranking alien officer is in the building next door. You order your men to storm the building. As you enter, you see the alien officer. He's fast. You remember the alien weapon, but firing it in this place might kill everyone. Use the weapon or capture him alive?",
        image: "/alien_leader.jpg",
        choices: {
            useWeapon: "death", 
            capture: "alienSurrender" 
        }
    },
    warnCommand: {
        description: "After looking over all the available intel, Command initiates a risky plan to destroy the alien mothership. You are given the option of leading the assault team or coordinating ground defenses. The fate of Earth rests on your decision.",
        image: "/assault_plan.jpg",
        choices: {
            leadAssault: "spaceAssault",
            coordinateGround: "groundCommand"
        }
    },
    infiltrateMothership: {
        description: "Sneaking through the labyrinth of corridors you discover the alien's central AI. It greets you in perfect English. You think back to the stories your grandfather told you about the first alien invasion. He said AI was the key to victory. Do you reprogram the AI or destroy it?",
        image: "/alien_ai.jpg",
        choices: {
            reprogram: "reprogramAI",
            destroy: "destroyAI"
        }
    },
    reprogramAI: {
        description: "You've successfully reprogrammed the alien AI. All those stories your grandfather told you about the first invasion were true. The AI is now under your control. It offers to help negotiate peace or sabotage the alien fleet.",
        image: "/reprogrammed_ai.jpg",
        choices: {
            tryPeace: "negotiatePeace",
            sabotageFleet: "fleetSabotage"
        }
    },
    destroyAI: {
        description: "The AI is destroyed, throwing the alien forces into disarray. But you've triggered a self-destruct sequence. Try to escape or look for a way to stop it?",
        image: "/mothership_selfdestruct.jpg",
        choices: {
            escape: "mothershipeEscape",
            stopSequence: "preventExplosion"
        }
    },
    negotiatePeace: {
        description: "The AI has opened communication channels. The alien leader is willing to talk. Demand their surrender or offer a compromise?",
        image: "/alien_negotiations.jpg",
        choices: {
            demandSurrender: "alienSurrender",
            offerCompromise: "peaceTreaty"
        }
    },
    fleetSabotage: {
        description: "The alien fleet is crippled, and ships are crash-landing all over Earth. Pursue the crash sites or return to defend the capitol?",
        image: "/crashing_ships.jpg",
        choices: {
            pursueCrash: "crashSiteConfrontation",
            defendCapitol: "urbanDefense"
        }
    },
    spaceAssault: {
        description: "You lead an assault team to the mothership. The alien fleet is in disarray. With expert piloting skills you land in an open hangar bay. You head deeper into the mothership. ",
        image: "/space_battle.jpg",
        choices: {
            continue: "infiltrateMothership"
        }
    },
    groundCommand: {
        description: "Manning the main defense console you anxiously await word from the space assault team. The alien fleet is closing in. You hear the voice of your grandfather in your head. He says: See that big ship? That's what you should have picked. The last thing you see is the brilliant flash of the mothership's main weapon.",
        image: "/mothership_blast.jpg",
        choices: {
            continue: "death"
        }
    },
    mothershipeEscape: {
        description: "You've escaped in an alien pod, but it's damaged. Attempt a risky landing or try to dock with a human space station?",
        image: "/damaged_pod.jpg",
        choices: {
            riskyLanding: "podLanding",
            spaceStation: "stationDocking"
        }
    },
    preventExplosion: {
        description: "You've found the central reactor. Aliens are closing in. Overload it to take out the mothership or try to shut it down safely?",
        image: "/alien_reactor.jpg",
        choices: {
            overload: "reactorOverload",
            shutDown: "safeShutdown"
        }
    },
    alienSurrender: {
        description: "The aliens have surrendered. People take to the streets and cheer for the brave warriors who saved them. You look at your squad and they nod back. This is the turning point humanity needed. Do you imprison the alien leaders or offer amnesty in exchange for their advanced technology?",
        image: "/alien_surrender.jpg",
        choices: {
            imprison: "alienPrisoners",
            amnesty: "technologyExchange"
        }
    },
    peaceTreaty: {
        description: "A peace treaty is signed. The aliens offer to share their space exploration technology and want to travel the cosmos together. They say they respect humans because of you. Accept their offer or politely decline?",
        image: "/treaty_signing.jpg",
        choices: {
            accept: "jointSpaceProgram",
            decline: "preserveIndependence"
        }
    },
    crashSiteConfrontation: {
        description: "At a nearby crash site, you find surviving aliens. They're injured and scared. Capture them or offer medical assistance?",
        image: "/crash_survivors.jpg",
        choices: {
            capture: "alienPOWs",
            assist: "alienGratitude"
        }
    },
    urbanDefense: {
        description: "You've reached the city. The aliens are attacking in waves and local forces are unorganized. Do you order a mass evacuation or fortify the city for a last stand?",
        image: "/city_defense.jpg",
        choices: {
            evacuate: "massEvacuation",
            fortify: "lastStand"
        }
    },
    podLanding: {
        description: "You've crash-landed in a remote area. The pod is damaged, but you're alive. Do you send a distress signal or go silent? You decide to disable the beacon and go silent.",
        image: "/pod_crashsite.jpg",
        choices: {
            disable: "goingSilent"
        }
    },
    stationDocking: {
        description: "You've reached an independent civilian space station, but they're wary of your alien pod. Surrender immediately or try to explain the situation?",
        image: "/space_station_standoff.jpg",
        choices: {
            surrender: "uneasyAlliance",
            explain: "uneasyAlliance"
        }
    },
    uneasyAlliance: {
        description: "The station commander listens, but trust is thin. You're given a chance to prove your intentions. You offer to help with station repairs.",
        image: "/negotiating_table.jpg",
        choices: {
            helpRepairs: "stationRepairs"
    }
},
    stationRepairs: {
        description: "Your knowledge of alien tech speeds up repairs, but some crew members are suspicious of your methods. Your next move is to either integrate with the crew or continue working alone.",
        image: "/tech_repair.jpg",
        choices: {
            integrate: "crewIntegration",
            alone: "alienSpecialist"
    }
},
    reactorOverload: {
        description: "The mothership explodes, taking out the alien fleet. You escaped, but now you are adrift in space. As you float off into the void, you think you can hear: Thanks for playing.",
        image: "/mothership_explosion.jpg",
        choices: {
            continue: "death"
        }
    },
    safeShutdown: {
        description: "You've shut down the reactor, preventing the explosion. The mothership is disabled and the alien fleet retreats. You've saved the day. Do you explore the ship or return to Earth?",
        image: "/mothership_disabled.jpg",
        choices: {
            exploreShip: "alienTechnology",
            returnEarth: "preserveIndependence"
        }
    },
    alienTechnology: {
        description: "You've just stumbled on to some serious alien tech. Your soldiers know you found the motherlode and set up a defensive position. Do you study it or destroy it? The choice is yours.",
        image: "/alien_tech.jpg",
        choices: {
            studyTech: "alienSpecialist",
            destroyTech: "humanResilience" 
        }
    },
    alienPrisoners: {
        description: "The alien leaders go without a fight. You've captured them, but they're not talking. Do you interrogate them or offer them a chance at redemption?",
        image: "/alien_prisoners.jpg",
        choices: {
            interrogate: "alienPOWs",
            redemption: "alienRedemption"
        }
    },
    crewIntegration: {
        description: "You become part of the crew, but your alien origins are never fully accepted. A small incident sparks rumors, and soon, conspiracy theories about your true motives lead to panic.",
        image: "/public_panic.jpg",
        choices: {
            continue: "alienSpecialist"
        }
},
    technologyExchange: {
        description: "You've exchanged technology with the aliens. The level of advancement to all humans is staggering. As the new President of the Federated Worlds, you have a choice to make. Do you focus on space exploration or help rebuild your planet?",
        image: "/technology_exchange.jpg",
        choices: {
            spaceFocus: "newFrontiers",
            earthFocus: "jointReconstruction"
        }
    },
    jointSpaceProgram: {
        description: "Humanity and aliens launch a joint space program. You feel the weight of the galaxy on your shoulders. Do you volunteer for the program or stay on Earth?",
        image: "/joint_space_program.jpg",
        choices: {
            volunteer: "newFrontiers",
            stayEarth: "jointReconstruction"
        }
    },
    preserveIndependence: {
        description: "Humanity has preserved its independence. World leaders are looking to you for guidance. Do you prepare for future invasions or focus on rebuilding Earth?",
        image: "/independent_humanity.jpg",
        choices: {
            prepareEncounters: "defenseLeader",
            rebuildEarth: "humanResilience"
        }
    },
    alienPOWs: {
        description: "The captured aliens are cooperative. A mixture of fear and curiosity is in their eyes. Do you study their biology or learn about their culture?",
        image: "/alien_captives.jpg",
        choices: {
            studyBiology: "alienBiology",
            learnCulture: "newFrontiers"
        }
    },
    alienGratitude: {
        description: "The surviving aliens are grateful for your assistance. One of them happens to be a high-ranking diplomat. They tell you they have been forced into this invasion and offer to help you end it peacefully. You are skeptical, but intrigued.",
        image: "/alien_gratitude.jpg",
        choices: {
            continue: "alienDiplomacy"
            
        }
    },
    massEvacuation: {
        description: "You've ordered a mass evacuation of the city. As the last shuttles leave, you see the alien fleet approaching. You board the last shuttle and watch as the city is destroyed.",
        image: "/evacuation_counterattack.jpg",
        choices: {
            continue: "junoGuardian"
        }
    },
    lastStand: {
        description: "You've fortified the city and the aliens are relentless, but so are you. The impenetrable defenses hold, sending the aliens into a retreat. Civilians are cheering your leadership. You've won.",
        image: "/fortified_city.jpg",
        choices: {
            continue: "defenseLeader"
        }
    },
    goingSilent: {
        description: "You've disabled the distress beacon. You listen to the sounds of the distant ongoing invasion. As you are trying to get the comms up and running with no luck, a family fleeing the planet gives you a ride back to awaiting evacuation shuttles. You make your way back to Stargaze Command HQ.",
        image: "/silent_pod.jpg",
        choices: {
            continue: "quietLife"
            
        }
    },
    // Good Endings
    newFrontiers: {
        description: "You lead humanity into a new era of interstellar exploration and cooperation. Your bravery during the invasion has paved the way for a brighter future for all species. Humanity joins the galactic community as equals. The first time you step onto a far-off alien world, you know that you've made the right choice.",
        image: "/interstellar_exploration.jpg",
        outcome: "win"
    },
    peacefulRetirement: {
        description: "You retire as a celebrated hero. Your actions have ensured peace between humans and aliens. You spend your days sharing your experiences, inspiring the next generation. One day, a young cadet asks you if you would do it all again. You smile and say: In a heartbeat.",
        image: "/hero_retirement.jpg",
        outcome: "win"
    },
    defenseLeader: {
        description: "Under your leadership, Earth's defenses become the most advanced in the galaxy. Your experience ensures that humanity will never again be caught off-guard. You are hailed as the savior of Earth. You've saved the planet, but your work is not done. The galaxy is vast, and new threats are always on the horizon.",
        image: "/advanced_defenses.jpg",
        outcome: "win"
    },
    alienDiplomacy: {
        description: "As Stargaze Command's ambassador, you forge strong alliances across the galaxy. Your diplomatic missions prevent countless conflicts and foster unprecedented cooperation. You are instrumental in the formation of the Galactic Alliance, a beacon of peace and unity. You've saved the galaxy from war, but your greatest challenge lies ahead.",
        image: "/galactic_alliance.jpg",
        outcome: "win"
    },
    jointReconstruction: {
        description: "The rebuilt capitol becomes a symbol of human-alien cooperation. Your decision to work together ushers in an era of unprecedented technological advancement and cultural exchange. You've saved Earth, but your work is far from over. The galaxy is full of wonders and dangers. You've made the right choices.",
        image: "/futuristic_city.jpg",
        outcome: "win"
    },
    alienRedemption: {
        description: "The alien leaders reveal the true nature of the invasion. They were forced into it by a rogue faction. They offer to help you end the conflict and bring the rogue faction to justice. You work together to defeat the faction and restore peace. The galaxy is a safer place because of your actions.",
        image: "/alien_redemption.jpg",
        outcome: "win"
    },

    // Bad Endings
    quietLife: {
        description: "You return to civilian life, haunted by the invasion. Without your leadership, Earth's defenses weaken. When a new threat emerges, humanity is unprepared. The invasion is swift and brutal. The aliens don't stop there. They move on to other worlds, leaving a trail of destruction in their wake.",
        image: "/quiet_life.jpg",
        outcome: "lose"
    },
    junoGuardian: {
        description: "You return to Earth a few years later, after the aliens have had their way with it. Isolation from the galactic community leaves the planet vulnerable. When a cosmic disaster strikes, Earth has no allies to turn to. The planet is lost, and humanity's future is uncertain. ",
        image: "/cosmic_disaster.jpg",
        outcome: "lose"
    },
    humanResilience: {
        description: "Rebuilding independently proves costly and slow. The strain leads to global conflicts over resources. In our discord, we fail to see a new, greater threat approaching. The aliens return, and this time, humanity is divided and unprepared. The invasion is swift and brutal. Children read about the fall of Earth in history books.",
        image: "riots.jpg",
        outcome: "lose"
    },
    returnToDuty: {
        description: "Back in military service, you struggle to convey the complexity of alien relations. Misunderstandings escalate, leading to a new, even more devastating war. The galaxy is plunged into chaos. You are haunted by the lives lost and the worlds destroyed. You wonder if there was another way.",
        image: "/renewed_war.jpg",
        outcome: "lose"
    },
    alienSpecialist: {
        description: "Your expertise is invaluable, but some see you as compromised. Conspiracy theories spread, causing panic. In the chaos, crucial alien technology is destroyed, setting humanity back decades. Your story makes it into the history books, but not in the way you hoped.",
        image: "riots.jpg",
        outcome: "lose"
    },
    alienBiology: {
        description: "Your study of alien biology leads to a breakthrough in medical science. However, the aliens see your research as a violation of their privacy. They cut off all contact with humanity. The galaxy is a dangerous place, and humanity is alone once more.",
        image: "/alien_biology.jpg",
        outcome: "lose"
    },
    victory: {
        description: "Your actions have led to a decisive victory against the alien forces. Earth is saved!",
        image: "/earth_saved.jpg",
        outcome: "win"
    },
    death: {
        description: "You've made the ultimate sacrifice. Your bravery will be remembered.", 
        image: "/soldier_memorial.jpg",
        outcome: "death"
    },
};

    let keplr;
    let walletAddress = '';
    let audio;
    let unsubscribe;
    let showModal = false;
    let feedback = '';
    let submissionStatus = '';
    let isLoading = false;
    let transactionCleared = false;
    let showStartImage = false;
    let gameEnded = false;
    let currentStep = "start";
    let gameState = adventure[currentStep];
    let nextGameState = null;
    let readableChoices = [];
    let outcomeMessage = "";
    let outcomeImage = "";
    let playCount = 0; // Initialize play counter
    let showReportButton = true; // Control visibility of the report button

    // Initialize Keplr and other setup on component mount
    onMount(async () => {
        if (window.keplr) {
            try {
                keplr = window.keplr;
                await keplr.enable("stargaze-1");
                console.log("Keplr enabled successfully");
            } catch (error) {
                console.error("Error enabling Keplr:", error.message);
                alert("Failed to enable Keplr. Please check the console for more details.");
            }
        } else {
            alert("Please install Keplr extension");
        }

        fetchPlayCount();

        unsubscribe = initialAudio.subscribe(async value => {
            if (audio) {
                await audio.pause(); // Ensure pause is completed
            }
            audio = value;
            if (audio) {
                await audio.play().catch(error => console.error('Error playing audio:', error));
            } else {
                audio = new Audio('/intro.mp3');
                audio.loop = true;
                await audio.play().catch(error => console.error('Error playing audio:', error));
                initialAudio.set(audio);
            }
        });

        document.addEventListener('visibilitychange', handleVisibilityChange);
    });

    onDestroy(() => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        if (unsubscribe) {
            unsubscribe();
        }
        if (audio) {
            audio.pause();
            audio = null;
        }
    });

    function toReadableFormat(camelCase) {
        return camelCase
            .replace(/([a-z])([A-Z])/g, '$1 $2') 
            .replace(/^./, str => str.toUpperCase()); 
    }

    function getReadableChoices(choices) {
        return Object.keys(choices).map(key => ({
            key,
            readable: toReadableFormat(key)
        }));
    }

    async function fetchPlayCount() {
        const response = await fetch('https://app.stargazecommand.com/playCount.php');
        const data = await response.json();
        playCount = data.playCount;
    }

    async function incrementPlayCount() {
        const response = await fetch('https://app.stargazecommand.com/playCount.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();
        playCount = data.playCount;
    }

    $: if (gameState.choices) {
        readableChoices = getReadableChoices(gameState.choices);
    }

    function makeChoice(choice) {
        nextGameState = adventure[gameState.choices[choice]];

        setTimeout(() => {
            gameState = nextGameState;
            nextGameState = null;

            if (gameState.outcome === "death" || gameState.outcome === "win" || gameState.outcome === "lose") {
                outcomeMessage = gameState.description;
                outcomeImage = gameState.image;
                gameEnded = true; 
            } 
        }, 0);
    }

    async function resetGame() {
        await incrementPlayCount(); // Increment play counter on the server
        currentStep = "start";
        gameState = adventure[currentStep];
        transactionCleared = false;
        showStartImage = false;
        showReportButton = true; // Show the report button when the game is reset
        if (audio) {
            await audio.pause(); // Ensure pause is completed
            audio.currentTime = 0; 
        }
        audio = new Audio('/intro.mp3');
        audio.loop = true;
        await audio.play().catch(error => console.error('Error playing audio:', error));
        initialAudio.set(audio); 
        gameEnded = false; 
    }

    function handleVisibilityChange() {
        if (document.hidden) {
            if (audio) {
                audio.pause();
            }
        } else {
            if (audio) {
                audio.play().catch(error => console.error('Error playing audio:', error));
            }
        }
    }

    async function createtxn() {
        if (!keplr) {
            alert("Keplr is not connected");
            return;
        }

        isLoading = true; 

        const chainId = "stargaze-1";
        const recipient = "stars1mk2yasfjljrvrxrjwj5823xh6lctkjc9lq28ch"; 
        const amount = {
            denom: "ustars",
            amount: "25000000" 
        };
        const memo = "I put a quarter in at Stargaze Command";

        try {
            const offlineSigner = keplr.getOfflineSigner(chainId);
            const accounts = await offlineSigner.getAccounts();
            const account = accounts[0];

            const client = await SigningStargateClient.connectWithSigner(
                "https://stargaze-rpc.polkachu.com", 
                offlineSigner
            );

            const fee = {
                amount: [{ denom: "ustars", amount: "5000" }], 
                gas: "200000" 
            };

            const result = await client.sendTokens(
                account.address,
                recipient,
                [amount],
                fee,
                memo
            );

            if (result.code !== undefined && result.code !== 0) {
                alert("Failed to send transaction: " + result.log);
            } else {
                alert("Transaction sent successfully!");
                transactionCleared = true; 
                showReportButton = false; // Hide the report button when the transaction clears

                if (audio) {
                    await audio.pause(); // Ensure pause is completed
                }

                audio = new Audio('/background.mp3');
                audio.loop = true;
                await audio.play().catch(error => console.error('Error playing audio:', error));

                initialAudio.set(audio);

                showStartImage = true;
            }
        } catch (error) {
            console.error("Error sending transaction:", error.message);
            console.error("Error details:", error);
            alert("An error occurred while sending the transaction. Please check the console for more details.");
        } finally {
            isLoading = false; 
        }
    }

    function openModal() {
        showModal = true;
    }

    function closeModal() {
        showModal = false;
        submissionStatus = ''; // Reset submission status when closing the modal
    }

    async function submitFeedback() {
        const response = await fetch('https://app.stargazecommand.com/submit_feedback.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ walletAddress, feedback })
        });

        if (response.ok) {
            submissionStatus = 'success';
            console.log('Feedback submitted successfully');
        } else {
            submissionStatus = 'error';
            console.error('Failed to submit feedback');
        }

        // Optionally close the modal after submission
        setTimeout(closeModal, 3000); // Close modal after 3 seconds
    }
</script>

<main>
    <div class="logo-section">
        <img src="/logo.png" alt="Stargaze Command" class="logo" />
    </div>
    {#if !transactionCleared}
    <h1 class="animated-text">Please Deposit 25 cents</h1>
    <button on:click={createtxn} disabled={isLoading}>Put in Quarter</button>
    {/if}

    {#if isLoading}
    <div class="loading">
        <p>Transaction in progress...</p>
        <div class="spinner"></div>
    </div>
    {/if}
    {#if transactionCleared}
    <div class="content-box">
        <div class="outcome">
            <p>{gameState.description}</p>
        </div>
        {#if gameState.image}
        <!-- svelte-ignore a11y-img-redundant-alt -->
        <div class="image-container">
            <img src={gameState.image} alt="Adventure Image" class="adventure-image" />
        </div>
        {/if}
        {#if gameState.choices}
        <div class="choices">
            {#each readableChoices as choice}
                <button on:click={() => makeChoice(choice.key)}>{choice.readable}</button>
            {/each}
        </div>
        {/if}
        {#if gameEnded}
        <button on:click={resetGame}>Thanks For Playing</button>
        {/if}
    </div>
    {/if}

    <!-- Conditionally render the report button -->
    {#if showReportButton}
    <div>
    <button class="feedback-button" on:click={openModal} aria-label="Report a Bug / Feedback">Report a Bug / Feedback</button>
</div>
{/if}
    <p>Number of plays: {playCount}</p>
</main>

{#if showModal}
    <div class="modal">
        <div class="modal-content">
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span class="close" on:click={closeModal}>&times;</span>
            <h2>Report a Bug / Feedback</h2>
            <form on:submit|preventDefault={submitFeedback}>
                <label for="walletAddress">Wallet Address:</label>
                <input type="text" id="walletAddress" bind:value={walletAddress}>
                
                <label for="feedback">Feedback:</label>
                <textarea id="feedback" bind:value={feedback} required></textarea>
                
                <button type="submit">Submit</button>
            </form>
            {#if submissionStatus === 'success'}
                <p class="success-message">Feedback submitted successfully!</p>
            {/if}
            {#if submissionStatus === 'error'}
                <p class="error-message">Failed to submit feedback. Please try again.</p>
            {/if}
        </div>
    </div>
{/if}

<style>
    .success-message {
        color: #28a745;
        margin-top: 10px;
    }
    .error-message {
        color: #dc3545;
        margin-top: 10px;
    }

.feedback-button {
        display: block;
        margin: 10px auto 5px auto; /* Adjust bottom margin to 10px */
        padding: 0.5em 1em;
        font-size: 1em;
        cursor: pointer;
        border: 2px solid transparent;
        background-color: #28a745;
        color: #fff;
        border-radius: 10px;
        transition: background-color 0.3s, border-color 0.3s;
    }
    .feedback-button:hover {
        background-color: #218838;
    }
    .modal {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .modal-content {
        background-color: #000000;
        padding: 20px;
        border-radius: 10px;
        width: 80%;
        max-width: 500px;
        text-align: left;
        border: 2px solid #28a745; /* Green border */
    }
    .close {
        float: right;
        font-size: 1.5em;
        cursor: pointer;
        border: 1px solid #28a745; /* Green border */
        border-radius: 50%; /* Make the border circular */
        padding: 0.2em; /* Adjust padding to make it tighter */
        width: 1.5em; /* Set width */
        height: 1.5em; /* Set height */
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box; /* Include padding and border in the element's total width and height */
    }
    label {
        display: block;
        margin-top: 10px;
    }
    input, textarea {
        width: 100%;
        max-width: 100%;
        padding: 10px;
        margin-top: 5px;
        border: 1px solid #ccc;
        border-radius: 5px;
        box-sizing: border-box; /* Include padding and border in the element's total width and height */
    }
    button[type="submit"] {
        display: block;
        margin: 20px 0 0 auto;
        padding: 0.5em 1em;
        font-size: 1em;
        cursor: pointer;
        border: 2px solid transparent;
        background-color: #007bff;
        color: #fff;
        border-radius: 10px;
        transition: background-color 0.3s, border-color 0.3s;
    }
    button[type="submit"]:hover {
        background-color: #0056b3;
    }
    
    img {
    max-height: 50vh; 
    width: auto; 
}
    .loading {
        text-align: center;
        margin-top: 20px;
    }

    .spinner {
        border: 4px solid rgba(0, 0, 0, 0.1);
        border-left-color: #09f;
        border-radius: 50%;
        width: 36px;
        height: 36px;
        animation: spin 1s linear infinite;
        margin: 0 auto;
    }

    @keyframes spin {
        to { transform: rotate(360deg); }
    }
    a:link {
    color: rgb(253, 124, 64); 
}

a:visited {
    color: rgb(255, 255, 255); 
}

a:hover {
    color: rgb(255, 126, 20); 
}

a:active {
    color: rgb(180, 255, 6); 
}
    
    .animated-text {
        color: #ffffff; 
        animation: pulse 1s infinite; 
    }

    @keyframes pulse {
        0% {
            transform: scale(1);
            opacity: 1;
        }
        50% {
            transform: scale(1.1);
            opacity: 0.7;
        }
        100% {
            transform: scale(1);
            opacity: 1;
        }
    }
    .content-box {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background-color: #383535; 
        background-image: url('/galactic_alliance.jpg'); /* Add your background image here */
        background-size: cover; /* Ensure the image covers the entire content box */
        background-position: center; /* Center the background image */
        background-repeat: no-repeat; /* Prevent the image from repeating */
        padding: 10px 20px 20px 20px;
        border-radius: 10px; 
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); 
        margin: 5px 0; 
        max-width: 90%; 
        margin-left: auto;
        margin-right: auto;
        
    }
    .outcome {
        text-align: left;
        padding: 20px;
        border: 2px solid #ff6161;
        border-radius: 10px;
        background-color: rgba(0, 0, 0, 0.89);
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.521);
        font-size: 0.9em; 
        font-weight: 400;
    }
    footer {
        text-align: center;
        margin-top:0px;
        font-size: 0.9em;
        color: #ffffff;
    }
    .logo-section {
        max-width: 100%;
        text-align: center;
        padding: 0; /* Remove padding */
    }
    .logo {
        max-width: 40%;
        height: auto;
    }
    .adventure-image {
        max-width: 100%;
        height: 450px; /* Set a fixed height for all adventure images */
        object-fit: cover; /* Ensure the image covers the specified height while maintaining aspect ratio */
        margin: 5px 0;
    }
    .image-container {
        position: relative;
        display: inline-block;
    }
    .choices {
        margin-top: auto; /* Push the choices container to the bottom */
        display: flex;
        flex-direction: row; /* Align buttons side by side */
        justify-content: center; /* Center align the buttons horizontally */
    }
    @keyframes flash-border {
        0% {
            border-color: transparent;
        }
        50% {
            border-color: #fff;
        }
        100% {
            border-color: transparent;
        }
    }
    .choices button {
        font-size: 0.8em; /* Smaller text */
        margin-top: 10px; /* Space between buttons */
        padding: 0.5em 1em;
        border: none;
        border-radius: 5px;
        background-color: #007bff;
        color: white;
        cursor: pointer;
        transition: background-color 0.3s ease;
        text-transform: uppercase;
    }
    button {
        padding: 0.5em 1em;
        margin: 0.5em;
        border: none;
        border-radius: 5px;
        background-color: #007bff;
        color: white;
        font-size: 1.2em;
        cursor: pointer;
        transition: background-color 0.3s ease;
        text-transform: uppercase;
    }
    button:hover {
        background-color: #0056b3;
    }
    @media (max-width: 768px) {
        .logo-section {
            padding-top: 10px; 
        }

        .animated-text {
            font-size: 1rem; /* Smaller font size for mobile */
        }
        .logo {
            max-width: 80%; 
        }
        .adventure-image {
            height: 350px; /* Adjust height for smaller screens */
        }
    }
    @media (max-width: 480px) {
        .logo-section {
            padding-top: 5px; 
        }
        .logo {
            max-width: 70%; 
        }
        .adventure-image {
            height: 275px; /* Further adjust height for very small screens */
        }
    }
    @media (max-width: 380px) {
        .logo-section {
            padding-top: 5px; 
        }
        .logo {
            max-width: 30%; 
        }
        .adventure-image {
            height: 140px; /* Further adjust height for super small screens */
        }
    }
    .version-text {
        color: yellow;
    }

</style>

<footer>
    <p>Choose-Your-Own-Cryptoventure <span class="version-text">v1.44.3-Cliffhanger</span> by Justin</p>
    <p><a href="https://sdxl.akash.network/" target="_blank" rel="noopener noreferrer">
        Images generated with SDXL on AKASH and FLUX.1
    </a></p>
    <p><a href="https://maxkomusic.com/" target="_blank" rel="noopener noreferrer">
        "An Epic Story" and other music by MaxKoMusic
    </a></p>
</footer>